import { Navigate } from 'react-router-dom';
import storage from '../utils/storage';
import logger from '../utils/logger';

/**
 * Composant ProtectedRoute réutilisable pour sécuriser les routes
 * Vérifie l'authentification et l'autorisation basée sur les rôles
 * Supporte la redirection basée sur le rôle si redirectOnDeny est true
 */
const ProtectedRoute = ({ children, requiredRole, redirectOnDeny = false }) => {
  const token = storage.getToken();

  // Si pas de token, rediriger vers la page de connexion
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // Récupérer le rôle depuis le storage
  let userRole = storage.getRole();

  // Si le rôle n'est pas disponible, le décoder depuis le token
  if (!userRole) {
    try {
      const decoded = storage.decodeToken();
      if (decoded && decoded.role) {
        userRole = decoded.role;
      }
    } catch (error) {
      logger.error('Erreur lors du décodage du token:', error);
      storage.clearAll();
      return <Navigate to="/" replace />;
    }
  }

  // Normaliser le rôle
  const normUserRole = (userRole || '').toUpperCase();

  // Vérifier l'autorisation en fonction des rôles définis
  const isAllowed = () => {
    if (!requiredRole) return true;
    if (requiredRole.toUpperCase() === 'ADMIN') {
      return normUserRole === 'ADMIN';
    }
    if (requiredRole.toUpperCase() === 'PARTICIPANT' || requiredRole.toUpperCase() === 'CLIENT') {
      return normUserRole === 'CLIENT' || normUserRole === 'PARTICIPANT';
    }
    return normUserRole === requiredRole.toUpperCase();
  };

  if (!isAllowed()) {
    if (redirectOnDeny) {
      // Redirection basée sur le rôle (logique de PrivateRoute)
      switch (normUserRole) {
        case 'ADMIN':
          return <Navigate to="/administrateur" replace />;
        case 'GERANT':
          return <Navigate to="/gerant/gestion-sondages" replace />;
        case 'CLIENT':
        case 'PARTICIPANT':
          return <Navigate to="/participant" replace />;
        default:
          return <Navigate to="/" replace />;
      }
    } else {
      return <Navigate to="/non-autorise" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
